module.exports = __webpack_public_path__ + "img/000.31f93f71.png";